import React, { useState } from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';
import { GeneInput } from './GeneInput.tsx';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { Gene } from '../../utils/Gene.ts';

import { driver } from 'driver.js';

export const SuggestMorphModal = ({ genes, closeModal }: { genes: Gene[], closeModal: Function }) => {
    const [morphName, setMorphName] = useState('');
    const [selectedGenes, setSelectedGenes] = useState([{ id: 1, gene_name: '', gene_type: '', is_hom: false }]);
    const [description, setDescription] = useState('');

    const driverObj = driver({
        steps: [
            { element: '#suggest-morph-modal #morph', popover: { title: 'Morph Name', description: 'Type the name of the morph you are suggesting. Please check the morph list to verify this morph doesn\'t exist already.', position: 'bottom' } },
            { element: '#suggest-morph-modal #description', popover: { title: 'Description', description: 'Describe the morph you are suggesting. Please include any information that would be helpful to the community.', position: 'bottom' } },
            { element: '#suggest-morph-modal #genes-list', popover: { title: 'Genes', description: 'Select the genes that make up this morph. If you don\'t see the gene you are looking for, you can suggest it by clicking the "Suggest a Gene" button on the page before this one.', position: 'bottom' } },
            { element: '#suggest-morph-modal #add-another-btn', popover: { title: 'Add Another Gene', description: 'Add another gene to your morph suggestion.', position: 'bottom' } },
            { element: '#submit-morph-btn', popover: { title: 'Submit', description: 'Submit your morph suggestion for approval.', position: 'bottom' } },
        ]
    })

    const addGene = () => {
        setSelectedGenes([...selectedGenes, { id: selectedGenes.length + 1, gene_name: '', gene_type: '', is_hom: false }]);
    }

    const setGenes = (gene, index) => {
        let newGenes = [...selectedGenes];
        newGenes[index] = { ...newGenes[index], ...gene }
        setSelectedGenes(newGenes);
    }
    const submitMorph = () => {
        // check if morph name is filled out or has any non-whitespace characters
        if (!morphName || !morphName.trim()) {
            const morphInput = document.getElementById('morph');
            morphInput?.classList.add('is-invalid');
            return;
        }
        const submitGenes = selectedGenes.filter(gene => gene.gene_name).map(x => { return { name: x.gene_name, is_hom: x.is_hom } })
        const data = {
            name: morphName,
            description,
            reptile: localStorage.getItem('selectedReptile'),
            genes: submitGenes
        };
        BasicFetch({
            url: `${(window as any).serverLocation}reptile/create_morph`,

            method: 'POST',
            data: data,
            onSuccess: (resp) => {
                window.alert("Morph was successfully submitted for approval");
                closeModal();
            },
            onFail: () => {

            }
        });
    }

    return (
        <ReptoolModal id='suggest-morph-modal' title="Suggest A Morph" showTutorial={driverObj.drive} closeModal={() => closeModal(false)} body={
            <React.Fragment>
                <div className="mt-3 d-flex flex-column has-validation">
                    <h6>Morph Name:</h6>
                    <div className="ui-textinput ui-corner-all ui-shadow-inset ui-textinput-text ui-body-inherit">
                        <input id="morph" type="text" value={morphName} onChange={(event) => setMorphName(event.target.value)} className="w-100 form-control bg-black text-blue rounded" />
                        <div className="invalid-feedback">Morph name required</div>
                    </div>
                </div>
                <div id='description' className='mt-3'>
                    <h6>Description:</h6>
                    <textarea className='w-100' value={description} onChange={(event) => setDescription(event.target.value)} rows={3} />
                </div>
                <div id='genes-list' className='mt-3'>
                    <h6>Genes:</h6>
                    {selectedGenes.map((gene, index) => (
                        <React.Fragment key={index}>
                            <GeneInput id={index} genes={genes} gene={gene} setGene={(geneData) => setGenes(geneData, index)} />
                        </React.Fragment>
                    ))}
                </div>
                <div className='mt-3 d-flex flex-column'>
                    <div id='add-another-btn' onClick={() => addGene()} className="btn button w-100">Add another gene</div>
                    <div id='submit-morph-btn' onClick={() => submitMorph()} className="btn mt-3 button w-100">Submit Morph For Approval</div>
                </div>
            </React.Fragment>

        } />
    )
}